import * as React from "react";
import { PrimaryButton, DefaultButton } from "@fluentui/react/lib/Button";
import { Stack } from "@fluentui/react/lib/Stack";
import { Label } from "@fluentui/react/lib/Label";
import { useNavigate, useParams } from "react-router-dom";
import { Input } from "@fluentui/react-components";
import { AdminService, ApplicationUserDto } from "../../KulcsUzletSvc";

const MerchantForm: React.FC = () => {
  const { id } = useParams();
  const [merchant, setMerchant] = React.useState<
    ApplicationUserDto | undefined
  >();
  const [name, setName] = React.useState<string | undefined>();

  React.useEffect(() => {
    if (id) {
      const getMerchant = async () => {
        const res = await AdminService.getAdminApplicationUser(id).catch(
          (e) => {
            console.log(e);
          }
        );
        if (res) {
          setMerchant(res);
          setName(res.fullName ?? "");
        }
      };
      getMerchant();
    }
  }, [id]);

  const navigate = useNavigate();

  const navigateBack = () => {
    navigate(-1);
  };

  const handleSave = async () => {
    if (!merchant) return;
    await AdminService.postAdminApplicationUser(merchant)
      .then((res) => {
        if (res.isSuccess) {
          navigateBack();
        } else {
          alert(`A mentés nem sikerült: ${res.errorMsg ?? "-"}`);
        }
      })
      .catch((e) => console.log(e));
  };

  return (
    <Stack
      horizontalAlign="center"
      verticalAlign="start"
      styles={{ root: { width: "100%", marginTop: 40 } }}
    >
      <Stack
        styles={{
          root: {
            width: 500,
            border: "1px solid #ddd",
            padding: 24,
            borderRadius: 4,
            boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
          },
        }}
        tokens={{ childrenGap: 20 }}
      >
        <h2 style={{ textAlign: "center" }}>
          {id && name ? `${name} kereskedő szerkesztése` : "Új kereskedő"}
        </h2>

        <Stack tokens={{ childrenGap: 6 }}>
          <Label required htmlFor="merchantName">
            Kereskedő neve
          </Label>
          <Input
            id="merchantName"
            value={merchant?.fullName ?? ""}
            onChange={(e, data) =>
              setMerchant({ ...merchant, fullName: data.value })
            }
          />
        </Stack>

        <Stack tokens={{ childrenGap: 6 }}>
          <Label required htmlFor="username">
            Felhasználó név
          </Label>
          <Input
            id="username"
            value={merchant?.userName ?? ""}
            onChange={(e, data) =>
              setMerchant({ ...merchant, userName: data.value })
            }
          />
        </Stack>

        <Stack tokens={{ childrenGap: 6 }}>
          <Label required htmlFor="email">
            Email cím
          </Label>
          <Input
            id="email"
            type="email"
            value={merchant?.emailAddress ?? ""}
            onChange={(e, data) =>
              setMerchant({ ...merchant, emailAddress: data.value })
            }
          />
        </Stack>

        <Stack horizontal horizontalAlign="end" tokens={{ childrenGap: 10 }}>
          <DefaultButton text="Mégse" onClick={navigateBack} />
          <PrimaryButton text="Mentés" onClick={handleSave} />
        </Stack>
      </Stack>
    </Stack>
  );
};

export default MerchantForm;
